import { push } from 'connected-react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { generatePath } from 'react-router-dom';
import { HEARING_DETAILS_URL } from '../../../constants/urls';
import { allActiveHearingsSelector } from '../../../features/selectors/compositeSelectors';
import { HearingOverview } from './HearingOverview';
import { Pages } from '../../../constants/pages';

const CurrentHearingsPage = () => {
  const { t: translator } = useTranslation();
  const dispatch = useDispatch();

  const onHearingClick = (hearingItem) =>
    dispatch(push(generatePath(HEARING_DETAILS_URL, { id: hearingItem.key })));

  return (
    <div className="admin-page">
      <HearingOverview
        headerText={translator('pageNames.currentHearings')}
        initialShowGrid={true}
        hearingsSelector={allActiveHearingsSelector}
        disableEsdh={true}
        disableOwner={true}
        disableSelection={true}
        onHearingClick={onHearingClick}
        activePage={Pages.CurrentHearingsPage}
      />
    </div>
  );
};

export { CurrentHearingsPage };
